import React from 'react';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import pattern_16 from '../assets/images/background/pattern-16.png';
import about_1 from '../assets/images/resource/about-company-office-male.jpg';
import about_2 from '../assets/images/resource/about-company-review-male.jpg';
import about_3 from '../assets/images/resource/about-company-collaboration-male.jpg';
import about_4 from '../assets/images/resource/about-4.jpg';
import about_5 from '../assets/images/resource/about-swiftmaze-male.jpg';
const About_main = ({ }) => {
	  const url = "https://www.swiftmazetech.com/about/";
    const ogImage = `https://www.swiftmazetech.com${about_5}`;
    const description = "SwiftMaze Tech is a technology and digital services company with 10+ years of experience delivering web, software, ERP, CRM and marketing solutions for growing businesses.";
    return (
      < >
	   <Helmet>
        <title>About SwiftMaze Tech | IT, Software & Digital Solutions Company</title>
        <meta 
          name="description" 
          content={description} 
        />
        <meta name="robots" content="index,follow" />
        {/* <link rel="canonical" href="https://www.swiftmazetech.com/about/" /> */}
		  <link rel="canonical" href={url} />
      <meta property="og:title" content="About SwiftMaze Tech | IT, Software & Digital Solutions Company" />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About SwiftMaze Tech | IT, Software & Digital Solutions Company" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      </Helmet>
      	<section className="page-title">
		<div className="pattern-layer-one" style={{ backgroundImage: `url(${pattern_16})` }}></div>
		<div className="auto-container">
			<h2>ABOUT US</h2>
			<ul className="page-breadcrumb">
				{/* <li><a href="index.html">Home</a></li> */}
					<li><Link to="/">Home</Link></li>
				<li> About us</li>
			</ul>
		</div>
	</section>

	<section className="about-section">
		<div className="auto-container">
			<div className="sec-title">
				<div className="title">ABOUT COMPANY</div>
				<h2>You Can not Use Up <br/> Creativity.</h2>
			</div>
			<div className="row clearfix">
				<div className="content-column col-lg-6 col-md-12 col-sm-12">
					<div className="inner-column">
						<div className="text">At the heart of our mission is a desire to create meaningful change. We work with purpose-driven organizations to strengthen their branding, communication, and digital presence — helping them amplify the impact they make in the world. We believe that kindness, creativity, and clarity are the pillars of lasting transformation. Every project we take on is guided by compassion and a commitment to making a real difference.</div>
						<div className="blocks-outer">
							<div className="feature-block">
								<div className="inner-box">
									<div className="icon flaticon-award-1"></div>
									<h6>Experience</h6>
									<div className="feature-text">We’re powered by a passionate team of over 1,400 skilled software professionals, delivering innovative solutions and real-world impact across industries.</div>
								</div>
							</div>

							<div className="feature-block">
								<div className="inner-box">
									<div className="icon flaticon-technical-support"></div>
									<h6>Quick Support</h6>
									<div className="feature-text">We’ll help you test bold new ideas while sharing your.</div>
								</div>
							</div>
							
						</div>
						
						{/* <a href="https://www.youtube.com/watch?v=kxPCFljwJws" className="lightbox-image theme-btn btn-style-one"><span className="txt"><i className="play-icon"><img src="images/icons/play-icon.png" alt="" /></i>&ensp; intro Video</span></a> */}
						
					</div>
				</div>
				<div className="images-column col-lg-6 col-md-12 col-sm-12">
					{/* <div className="inner-column" style="background-image: url(images/icons/globe.png)"> */}
                    <div className="inner-column" style={{ backgroundImage: 'url("images/icons/globe.png")' }}>
						{/* <div className="pattern-layer" style="background-image: url(images/background/pattern-1.png)"></div> */}
                        <div className="pattern-layer" style={{ backgroundImage: 'url("images/background/pattern-1.png")' }}></div>
						<div className="images-outer parallax-scene-1">
							<div className="image" data-depth="0.10">
								<img src={about_1} alt="SwiftMaze team discussion in office workspace" />
							</div>
							<div className="image-two" data-depth="0.30">
								<img src={about_2} alt="SwiftMaze professionals collaborating on digital strategy" />
							</div>
							<div className="image-three" data-depth="0.20">
								<img src={about_3} alt="Team member presenting business growth ideas" />
							</div>
							<div className="image-four" data-depth="0.30">
								<img src={about_4} alt="Office collaboration meeting at SwiftMaze Technology" />
							</div>
						</div>
					</div>
					{/* <a href="/about" className="learn"><span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>Learn More About Company</a> */}
				</div>
				
			</div>
		</div>
	</section>
	<section className="counter-section">
		<div className="auto-container">
			<div className="inner-container">
				<div className="fact-counter">
					<div className="row clearfix">
						<div className="column counter-column col-lg-3 col-md-6 col-sm-12">
							<div className="inner wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
								<div className="content">
									<div className="count-outer count-box">
										<span className="count-text" data-speed="3000" data-stop="330">20</span>+
									</div>
									<h4 className="counter-title">ACTIVE CLIENTS</h4>
								</div>
							</div>
						</div>
						<div className="column counter-column col-lg-3 col-md-6 col-sm-12">
							<div className="inner wow fadeInLeft" data-wow-delay="300ms" data-wow-duration="1500ms">
								<div className="content">
									<div className="count-outer count-box alternate">
										<span className="count-text" data-speed="5000" data-stop="850">50</span>+
									</div>
									<h4 className="counter-title">PROJECTS DONE</h4>
								</div>
							</div>
						</div>

						
						<div className="column counter-column col-lg-3 col-md-6 col-sm-12">
							<div className="inner wow fadeInLeft" data-wow-delay="600ms" data-wow-duration="1500ms">
								<div className="content">
									<div className="count-outer count-box">
										<span className="count-text" data-speed="2000" data-stop="25">10</span>+
									</div>
									<h4 className="counter-title">TEAM ADVISORS</h4>
								</div>
							</div>
						</div>

						
						<div className="column counter-column col-lg-3 col-md-6 col-sm-12">
							<div className="inner wow fadeInLeft" data-wow-delay="900ms" data-wow-duration="1500ms">
								<div className="content">
									<div className="count-outer count-box">
										<span className="count-text" data-speed="3500" data-stop="10">3</span>+
									</div>
									<h4 className="counter-title">GLORIOUS YEARS</h4>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</section>
	{/* <section className="about-section-two" style="background-image: url(images/background/3.jpg)"> */}
    <section className="about-section-two"style={{ backgroundImage: 'url("images/background/3.jpg")' }}>
		<div className="auto-container">
			<div className="row clearfix">
				<div className="image-column col-lg-7 col-md-12 col-sm-12">
					<div className="inner-column">
						{/* <div className="circle-layer" style="background-image: url(images/background/pattern-10.png)"> */}
                        <div className="circle-layer" style={{ backgroundImage: 'url("images/background/pattern-10.png")' }}>
                        </div>
						<div className="image">
							<img src={about_5} alt="" />
						</div>
					</div>
				</div>
				
			
				<div className="skill-column col-lg-5 col-md-12 col-sm-12">
					<div className="inner-column">
						
						
						<div className="sec-title light">
							<div className="title">About SwiftMaze</div>
							<h2>Transform Your Business With The Leading IT Solution provider.</h2>
							<div className="text">We listen carefully. We advise with insight. We design collaboratively.
What matters most to us is building lasting relationships and creating satisfied clients.
Our success is measured not just in outcomes, but in how our clients feel about working with us.</div>
						</div>
						
						<div className="skills">
							<div className="skill-item">
							<div className="skill-header clearfix">
								<div className="skill-title">Web Development</div>
								<div className="skill-percentage">
								<div className="count-box">
									<span className="count-text">99</span>%
								</div>
								</div>
							</div>
							<div className="skill-bar">
								<div className="bar-inner">
								{/* yahan change */}
								<div className="bar progress-line" style={{ width: "99%" }}></div>
								</div>
							</div>
							</div>

							<div className="skill-item">
							<div className="skill-header clearfix">
								<div className="skill-title">Hire Chrome Extension Developer</div>
								<div className="skill-percentage">
								<div className="count-box">
									<span className="count-text">99</span>%
								</div>
								</div>
							</div>
							<div className="skill-bar">
								<div className="bar-inner">
								<div className="bar progress-line" style={{ width: "99%" }}></div>
								</div>
							</div>
							</div>

							<div className="skill-item">
							<div className="skill-header clearfix">
								<div className="skill-title">ERP system</div>
								<div className="skill-percentage">
								<div className="count-box">
									<span className="count-text">99</span>%
								</div>
								</div>
							</div>
							<div className="skill-bar">
								<div className="bar-inner">
								<div className="bar progress-line" style={{ width: "99%" }}></div>
								</div>
							</div>
							</div>

						</div>
						
						<a href="/services" className="theme-btn btn-style-two"><span className="txt">Learn More</span></a>
						
					</div>
				</div>
				
			</div>
		</div>
	</section>
      </>
        );
    };
    
    export default About_main;
